import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  phone: "",
  address: "",
  latitude: "",
  longitude: "",
  country: "",
  city: "",
  postalCode: "",
  countryCode: "us",
};

const departmentFormSlice = createSlice({
  name: "departmentForm",
  initialState,
  reducers: {
    setDepartmentForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetDepartmentForm: (state) => {
      return { ...initialState, countryCode: state.countryCode };
    },
  },
});

export const { setDepartmentForm, resetDepartmentForm } =
  departmentFormSlice.actions;
export default departmentFormSlice.reducer;
